import {createSmartAction} from 'redux-smart-actions';

export const getPostByPath = createSmartAction(({path}) => ({
  request: {
    url: `/mco-leclub-api/v1/post/${path}`,
  },
  meta: {requestKey: `/${path}`},
}));
